module.exports = __webpack_public_path__ + "static/media/flavour-eucalipto.08a35960.png";